class NotificationModalController {
  constructor(Authentication, ReactNotificationService) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      ReactNotificationService,
    });
  }
}

export default {
  template: `
      <r-notification-modal 
        on-close="ctrl.ReactNotificationService.onReactNotificationModalClose()" 
        is-open="ctrl.ReactNotificationService.isReactNotificationModalOpen" 
        notification="ctrl.ReactNotificationService.notification" 
      ></r-notification-modal>
    `,
  controller: NotificationModalController,
  controllerAs: 'ctrl',
};
